import React, { useEffect, useState } from 'react'
import CouponConfigurableLabel from '../../CouponConfigurableLabel';
import { labelMappings } from '../../../utils/utils';
import { ValueQtySwitchType } from '../../../types';

function ValueQtySwitch(props:ValueQtySwitchType) {
    const {onChange,value} = props;
    
    const qtyLabel = labelMappings['applicable-slab-qty'];
    const valueLabel = labelMappings['applicable-slab-value'];
    const [val , setVal] = useState(value);

    useEffect(()=>{
        setVal(value)
    },[value]);

  return (
    <div className='value-qty-switch-wrapper'>
        <span className={`value-qty-switch ${val===valueLabel?'value-qty-switch-active':''}`} onClick={()=>onChange(valueLabel)}>
            <CouponConfigurableLabel text='applicable-slab-value' style={{cursor:'inherit',color:'inherit'}}/>
        </span>
        <span className={`value-qty-switch ${val===qtyLabel?'value-qty-switch-active':''}`}onClick={()=>onChange(qtyLabel)}>
            <CouponConfigurableLabel text='applicable-slab-qty' style={{cursor:'inherit',color:'inherit'}}/>
        </span>
    </div>
  )
}

export default ValueQtySwitch